export default __webpack_public_path__ + "static/Wizard_04-3d59cf00fcdcd652353d2ca02206351b.webp";